import { Component, HostListener, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AceitesService } from 'src/app/pages/privado/services/saude/aceites.service';
@Component({
  selector: 'app-modal-ata',
  templateUrl: './modal-ata.component.html',
  styleUrls: ['./modal-ata.component.css']
})
export class ModalAtaComponent {
  @Input() nomeAta: any;
  @Input() id: any;
  file: any;
  fileLoad: boolean = false;
  beneficio: any;
  page: number = 1;
  totalPages: number = 0;
  isLoaded: boolean = false;
  pdfSrc: any;
  constructor(public activeModal: NgbActiveModal, private aceitesService: AceitesService, public sanitizer: DomSanitizer, private toast: ToastrService) { }
  // async ngOnInit() {
  afterLoadComplete(event: any) {
    this.totalPages = event._pdfInfo?.numPages;
    this.isLoaded = true;
  }
  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }
  prevPage() {
    if (this.page > 1) {
      this.page--;
    }
  }
  ngOnInit() {
    var self = this;
    this.aceitesService.getAtaFile(this.id).subscribe(
      (data: any) => {
        this.file = data;
        const reader = new FileReader();
        reader.addEventListener("loadend", function () { self.pdfSrc = reader.result; });
        reader.readAsArrayBuffer(data);
      });
  }
  @HostListener('window:keyup', ['$event'])
  checkCapture(event: any) {
    let documento = document?.getElementById('pdf');
    if (event.key == 'PrintScreen' && documento != null) {
      navigator.clipboard.writeText('');
      this.toast.error("Não é possível realizar captura de tela!");
      documento.style.opacity = '0';
      setTimeout(
        () => {
          documento!.style.opacity = '0.9';
        }, 3500
      );
    }
  }
}
const toBase64 = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});
const toByteArray = (file: any) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = () => resolve(new Uint8Array(reader.result as ArrayBuffer));
  reader.onerror = error => reject(error);
});